import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_BLACK, COLOR_WHITE } from "~/theme/colors";
import * as colors from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { GENERIC_TEXT_IMAGE_BANNER_CLASSES } from "./constants";

interface UseStylesProps {
  orientation: boolean;
  textColor?: string;
}

export const GenericTextImageBannerContainer = styled(
  ({ orientation, textColor, ...rest }: UseStylesProps & BoxProps) => (
    <Box {...rest} />
  ),
)<UseStylesProps>(({ theme, orientation, textColor }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    display: "flex",
    paddingBottom: theme.spacing(7),
    backgroundColor: colors.COLOR_ADDITIONAL_WARM_GRAY_3U,
    [BREAKPOINT_TABLET]: {
      paddingBottom: theme.spacing(9),
    },
    [BREAKPOINT_DESKTOP]: {
      paddingBottom: theme.spacing(16),
    },

    [`& .${GENERIC_TEXT_IMAGE_BANNER_CLASSES.grid}`]: {
      [BREAKPOINT_TABLET]: {
        flexDirection: orientation ? "row-reverse" : "row",
        justifyContent: "space-between",
      },
    },

    [`& .${GENERIC_TEXT_IMAGE_BANNER_CLASSES.title}`]: {
      marginTop: 39,
      marginBottom: theme.spacing(1),
      ...theme.typography.h3,
      textTransform: "inherit",
      color: textColor === "light" ? COLOR_WHITE : COLOR_BLACK,
      [BREAKPOINT_TABLET]: {
        marginTop: 0,
        marginBottom: theme.spacing(2),
        ...theme.typography.h2,
        textTransform: "inherit",
      },
      [BREAKPOINT_DESKTOP]: {
        maxWidth: 500,
        overflowWrap: "normal",
      },
    },

    [`& .${GENERIC_TEXT_IMAGE_BANNER_CLASSES.text}`]: {
      marginBottom: theme.spacing(1),
      ...theme.typography.body1,
      fontSize: 20,
      color: textColor === "light" ? COLOR_WHITE : COLOR_BLACK,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(2),
        ...theme.typography.h6,
      },
      [BREAKPOINT_DESKTOP]: {
        maxWidth: 500,
      },
    },

    [`& .${GENERIC_TEXT_IMAGE_BANNER_CLASSES.image}`]: {
      width: "100%",
      objectFit: "contain",
      cursor: "pointer",
      [BREAKPOINT_TABLET]: { height: 476 },
      [BREAKPOINT_DESKTOP]: { height: 552 },
    },
  };
});
